import React from "react";
import { getUrlWithQueryString } from "js/utils";
import AuthService from "js/utils/AuthService";
import { Redirect } from "react-router-dom";

const Formulario = ({
  token,
  accion: { _id, formulario = {}, alturaIframe },
  usuario: { username },
  isLoggedIn
}) => {
  const url = getUrlWithQueryString(formulario.url, { token, username });
  if (AuthService.loggedIn(isLoggedIn))
    return (
      <iframe
        key={_id}
        title={_id}
        src={url}
        width="100%"
        height={alturaIframe ? alturaIframe : "1300"}
        frameBorder={0}
      />
    );
  else return <Redirect to="/signin" />;
};

export default Formulario;
